export interface TutorialStatusConstructor {
  isPunchOutApprovalWarningSuppressed: boolean // Angular: Global.tutorials.approval.punchout_confirmation
}

export class TutorialStatus {
  // true once the user checked "Don't show this message again?" —
  // gates the PunchOut Items tutorial modal (BHV-041)
  readonly isPunchOutApprovalWarningSuppressed: boolean

  constructor(data: TutorialStatusConstructor) {
    this.isPunchOutApprovalWarningSuppressed =
      data.isPunchOutApprovalWarningSuppressed
  }
}
